export default __webpack_public_path__ + "static/media/toy2.e47ffd64.jfif";